import { applyTo, forEach, without } from 'ramda';

const mediaQueryList = window.matchMedia('(max-width: 790px)');

class MatchMobile {
  callbacks = [];

  constructor() {
    try {
      // Chrome & Firefox
      mediaQueryList.addEventListener('change', this.handleCallbacks.bind(this));
    } catch (e1) {
      try {
        // Safari
        mediaQueryList.addListener(this.handleCallbacks.bind(this));
      } catch (e2) {
        console.error(e2);
      }
    }
  }

  get isMobile() {
    return mediaQueryList.matches;
  }

  addListener(done) {
    this.callbacks.push(done);
  }

  handleCallbacks(e) {
    if (e.isTrusted) {
      forEach(applyTo(e.matches), this.callbacks);
    }
  }

  removeListener(done) {
    this.callbacks = without([done], this.callbacks);
  }
}

export default new MatchMobile();
